// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { parsePhoneNumberFromString } from "libphonenumber-js/core";
import metadata from "./phone.metadata.json";

function parsePhoneNumber(number) {
  return parsePhoneNumberFromString(number, "BR", metadata);
}

function formatPhoneNumber(number) {
  const phone = parsePhoneNumber(number);
  return phone.format("E.164");
}

function formatNational(number) {
  const phone = parsePhoneNumber(number);
  return phone.formatNational();
}

function isValid(phone) {
  return phone?.isValid();
}

function isOfType(phoneType, phone) {
  return phone?.getType() === phoneType;
}

const phoneUtils = {
  parsePhoneNumber,
  formatPhoneNumber,
  formatNational,
  isValid,
  isOfType,
};

export default phoneUtils;
